<template>
  <pt-holiday-manage class="pt-holiday-manage__withData" ref="pageIndex"></pt-holiday-manage>
</template>

<script>
import PtHolidayManage from './index'
export default {
  name: 'pt-holiday-manage__withData',
  components: {
    'pt-holiday-manage': PtHolidayManage
  },
  methods: {
    load () {
      this.$refs.pageIndex.load()
    }
  }
}
</script>
